import React from "react";
import {
  Box,
  Button,
  Container,
  Grid,
  Link,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { Telegram, Twitter } from "@mui/icons-material";
import FacebookOutlinedIcon from "@mui/icons-material/FacebookOutlined";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import footer_image from "../assets/footer.png";
import logo from "../assets/logo-2.png";

const links = [
  {
    name: "About",
    to: "https://solardex.finance/#about",
  },
  {
    name: "Tokenomics",
    to: "https://solardex.finance/#tokenomics",
  },
  {
    name: "Roadmap",
    to: "https://solardex.finance/#roadmap",
  },
  {
    name: "Team",
    to: "https://solardex.finance/#team",
  },
  {
    name: "Solar Token",
    to: "https://solscan.io/token/2wmKXX1xsxLfrvjEPrt2UHiqj8Gbzwxvffr9qmNjsw8g#holders",
    target: "_blank",
  },
  {
    name: "Solar Pre Sale",
    to: "https://solscan.io/token/2wmKXX1xsxLfrvjEPrt2UHiqj8Gbzwxvffr9qmNjsw8g#holders",
    target: "_blank",
  },
];

const Footer = () => {
  const matches = useMediaQuery("(max-width:750px)");

  return (
    <Box mt={12}>
      <Box textAlign="center" mb={4}>
        <img src={logo} alt="Solar Logo" />
        <Typography
          component="h2"
          variant="h2"
          sx={{ textShadow: "white 0px 0px 20px" }}
        >
          Solar Shepard
        </Typography>
      </Box>
      <Container>
        <Grid container spacing={8}>
          <Grid item xs={12} sm={4}>
            <Typography
              component="h4"
              fontFamily="Bangers"
              letterSpacing="0.12em"
              fontSize="18px"
              variant="h5"
              mb={3}
            >
              About
            </Typography>
            <Typography component="p">
              Solar Shepard is the first US based Solana Defi exchange that
              enables users to trade tokens on the Solana network. Solar plans
              to eliminate rug pulls by having our smart contracts automatically
              lock liquidity at a minimum of 3 months. Any token not using
              Solar. Is most likely a scam
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography
              component="h4"
              fontFamily="Bangers"
              letterSpacing="0.12em"
              fontSize="18px"
              variant="h5"
              mb={3}
            >
              Follow us
            </Typography>
            <Link
              href="https://twitter.com/solar_dex?s=21"
              target="_blank"
              rel="noopener"
              mr={2}
              color="#26D2D1"
              fontSize="2rem"
            >
              <Twitter fontSize="inherit" />
            </Link>
            <Link
              href="https://t.me/solardexofficialchat"
              target="_blank"
              rel="noopener"
              color="#26D2D1"
              fontSize="2rem"
              mr={2}
            >
              <FacebookOutlinedIcon fontSize="inherit" />
            </Link>
            <Link
              href="https://t.me/solardexofficialchat"
              target="_blank"
              rel="noopener"
              color="#26D2D1"
              fontSize="2rem"
              mr={2}
            >
              <LinkedInIcon fontSize="inherit" />
            </Link>
            <Link
              href="https://t.me/solardexofficialchat"
              target="_blank"
              rel="noopener"
              color="#26D2D1"
              fontSize="2rem"
            >
              <Telegram fontSize="inherit" />
            </Link>
            <Typography
              component="p"
              fontFamily="Poppins"
              fontWeight={400}
              letterSpacing="0.27em"
              fontSize="12px"
              variant="subtitle1"
              mt={2}
            >
              All rights reserved @solar_shepard 2021
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography
              component="h4"
              fontFamily="Bangers"
              letterSpacing="0.12em"
              fontSize="18px"
              variant="h5"
              mb={3}
            >
              Subscribe Now
            </Typography>
            <Box bgcolor="#190436" height="37px">
              <input
                type="email"
                placeholder="write your Email"
                style={{
                  borderRadius: "4px",
                  backgroundColor: "transparent",
                  height: "37px",
                  border: "none",
                  outline: "none",
                  padding: "0px 5px",
                  width: matches ? "80%" : "77%",
                  color: "#fff",
                }}
              />
              <Button
                variant="contained"
                style={{
                  backgroundColor: "#26D2D1",
                  color: "#190436",
                  borderStartStartRadius: "20px",
                  borderEndStartRadius: "20px",
                  fontFamily: "Bangers",
                  fontWeight: 400,
                  fontSize: "10px",
                  letterSpacing: "0.12em",
                  height: "37px",
                  width: "77px",
                }}
              >
                send
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
      <Box component="hr" my={8} />
      <Box
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
        gap={{ xs: 3, sm: 4 }}
        mb={4}
      >
        {links.map(({ name, to }) => (
          <Link
            key={name}
            href={to}
            target="_blank"
            style={{
              fontFamily: "Bangers",
              fontWeight: 400,
              fontSize: "12px",
              textDecoration: "none",
              letterSpacing: "0.27em",
              color: "#fff",
            }}
            rel="noreferrer"
          >
            {name}
          </Link>
        ))}
      </Box>
      <img src={footer_image} alt="" width="100%" />
    </Box>
  );
};

export default Footer;
